import React from 'react';
import {Link} from 'react-router';
import moment from 'moment';
import { Popover, PopoverInteractionKind, Position } from '@blueprintjs/core';
import {ShowIf} from 'components/utils';
import {checkServerLive} from 'constants/config';
import fileDownload from 'js-file-download';
import {downloadFile} from 'components/utils';

class RowItemBaoCaoDinhKyChiTiet extends React.Component {

  render() {
    return (
      <tr>
        <td className='column-stt-fixed'>{this.props.count}</td>
        <td className='list-items-table'><Link className="txt-underline txt-regular" to={`/thong-ke-bao-cao/lap-bao-cao-dinh-ky/${this.props.item.baoCaoDonViChiTietId}`}>{this.props.item.loaiBaoCaoInfo ? this.props.item.loaiBaoCaoInfo.ten : ''}</Link></td>
        <td className='txt-left'>{this.props.item.ngayNop ? moment(this.props.item.ngayNop).format('DD/MM/YYYY') : ''}</td>
        <td className='txt-left'>
          {this.props.item.trangThaiBaoCaoInfo ? this.props.item.trangThaiBaoCaoInfo.ten : ''}
          {
            !this.props.item.soLieuMoiNhat ?
              <Popover
                interactionKind={PopoverInteractionKind.HOVER}
                position={Position.BOTTOM}
              >
                <span className="pt-icon-standard pt-icon-error ml10" />
                <div className="popover-content">
                  Biểu mẫu chưa được chốt <br/> với phiên bản mới nhất
                </div>
              </Popover>
            :''
          }
        </td>
        <td>
          <ul className="list-items-table">
            {
              this.props.item.listTaiLieuBaoCao.map((item, i) => {
                if(item.required) {
                  if (!checkServerLive) {
                    return <li key={i}><Link className="txt-blue txt-underline" onClick={fileDownload.bind(this, item.urlFile, item.tenFile)}>{item.tenFile}</Link></li>
                  }
                  if (checkServerLive) {
                    return <li key={i}><Link className="txt-blue txt-underline" onClick={()=>{downloadFile(item.urlFile, item.tenFile)}}>{item.tenFile}</Link></li>
                  }
                } else {
                  return null
                }
              })
            }
          </ul>
        </td>
      </tr>
    );
  }
}

export default RowItemBaoCaoDinhKyChiTiet;



// WEBPACK FOOTER //
// ./src/components/modules/bao-cao-dinh-ky/datatable/RowItemBaoCaoDinhKyChiTiet.jsx